// extracted by mini-css-extract-plugin
export default {"container":"DK-z","timeTop":"EK-z","timeCountdown":"FK-z","cta":"GK-z","disabled":"HK-z","product":"IK-z"};